/**
 * Где живёт игровой сервер.
 *
 * ⚠️ АДРЕС ОТДЕЛЬНЫЙ, А НЕ «ОТКУДА ОТДАЛАСЬ СТРАНИЦА», И В ЭТОМ ВЕСЬ СМЫСЛ
 * ВЫНОСА. Раньше сервер жил внутри dev-сервера Vite, и клиент звал его по
 * своему же адресу — `io()` без аргументов. Пока и то и другое лежало на
 * одном localhost, это работало; на разных хостингах — нет, а в собранной
 * игре сервера не было вовсе, потому что плагин стоял с `apply: 'serve'`.
 *
 * Значение задаётся при сборке через VITE_GAME_SERVER_URL. По умолчанию —
 * тот же хост, что у страницы, но порт игрового сервера: так работает и
 * localhost, и проверка с телефона по адресу машины в местной сети.
 */
const fromEnv = import.meta.env.VITE_GAME_SERVER_URL as string | undefined;

export const GAME_SERVER_URL: string =
  fromEnv !== undefined && fromEnv !== ''
    ? fromEnv.replace(/\/+$/, '')
    : `${location.protocol}//${location.hostname}:5182`;

/** Полный адрес ручки сервера. */
export function gameServerUrl(path: string): string {
  return `${GAME_SERVER_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
